import { render, staticRenderFns } from "./ActionsSubscribe.vue?vue&type=template&id=12a9b872&scoped=true&"
import script from "./ActionsSubscribe.vue?vue&type=script&lang=js&"
export * from "./ActionsSubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9b872",
  null
  
)

export default component.exports